import React, { useEffect, useState } from 'react';
import { PlayButton } from '@yme/assets/icons';
import { Image } from '@yme/atoms/image';
import { SVGIcon, ICON_SIZE } from '@yme/atoms/svg-icon';
import { useWindowSize } from '@yme/hooks/index';
import { useTranslation } from '@yme/services/i18n';
import { BREAKPOINT } from '@yme/tokens/screen';
import { PreviewImageStyled, VPlayButtonStyled } from './styled';
export function PreviewVideoImage(props) {
    const [isShowImagePreview, setIsShowImagePreview] = useState(true);
    const [svgSize, setSvgSize] = useState(ICON_SIZE.xxxxl);
    const size = useWindowSize();
    const { t } = useTranslation();
    const { previewImage, onClick, isPlaying } = props;
    // TODO: Need adjust this case
    const srcPreviewImage = previewImage?.src || '';
    if (!srcPreviewImage) {
        return null;
    }
    const imageAttrs = {
        src: srcPreviewImage,
        srcSet: previewImage?.srcSet || [],
        decorative: false,
        displayPopupTitle: false,
    };
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(() => {
        if (isPlaying) {
            // TODO: Need adjust this implementation (Play button should be hide)
            setTimeout(() => setIsShowImagePreview(false), 400);
        }
    }, [isPlaying]);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(() => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        const newSize = size.width < BREAKPOINT.lg ? ICON_SIZE.l : ICON_SIZE.xxxxl;
        setSvgSize(newSize);
    }, [size.width]);
    return (React.createElement(PreviewImageStyled, { isShowImagePreview: isShowImagePreview },
        React.createElement(Image, { ...imageAttrs }),
        React.createElement(VPlayButtonStyled, null,
            React.createElement(SVGIcon, { type: PlayButton, size: svgSize, onClick: onClick, "aria-label": t('common_play_accessibility') }))));
}
PreviewVideoImage.displayName = 'PreviewVideoImage';
